export const ADS_SIMULATOR_PAGE = [
  '113333408388614', //TEST LAZ 2
  '188869521221562', //Lazada
  '462339517184685', //City Fresh Fruit
  '178316699484910', // TISCO Autocash
  '101741676349041', // seagull test
  '183770551641122',
  '148559413337' //TOA Paint
]



// WEBPACK FOOTER //
// ./src/constants/adsSimulator.js